export default `
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-size: 14px;
}

.fbhr {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  padding: 3rem 1.5rem;
  font-family: "Roboto Condensed", sans-serif;
  font-size: 1rem;
  font-weight: normal;
  line-height: 1.875;
  color: var(--txt_color_3);
}

.fbhr h1 {
  font-size: 2.625rem;
  font-weight: bold;
  line-height: 1.3;
  letter-spacing: 0.25px;
  margin-bottom: 1.875rem;
}

.fbhr h2 {
  font-size: 2.063rem;
  font-weight: bold;
  line-height: 1.3;
  letter-spacing: 0.25px;
  margin-top: 3.75rem;
  margin-bottom: 1.875rem;
}

.fbhr h3 {
  font-size: 1.625rem;
  font-weight: bold;
  line-height: 1.4;
  letter-spacing: 0.15px;
  margin-top: 2.375rem;
  margin-bottom: 1.1875rem;
}

.fbhr h4 {
  font-size: 1.25rem;
  font-weight: bold;
  line-height: 1.4;
  letter-spacing: 0.15px;
  margin-bottom: 0.75rem;
}

.fbhr a {
  text-decoration: underline;
}

.fbhr .oblique {
  font-style: oblique;
}

.fbhr p,
.fbhr ul {
  margin-bottom: 1.875rem;
}

.fbhr ul {
  margin-left: 1.875rem;
}

.fbhr li {
  margin-bottom: 0.75rem;
}

.fbhr .showCookieManagementButton {
  cursor: pointer;
  text-decoration: underline;
}

/* Extra large */
@media (min-width: 1200px) {
  html {
    font-size: 16px;
  }

  .fbhr {
    padding: 3rem 0;
  }
}

</style>

<div class="fbhr">
<h1 class="text-center">Politika kolačića</h1>
<p>FAVORIT SPORTSKA KLADIONICA d.o.o. (u nastavku FSK), Draškovićeva 45, 10000 Zagreb, OIB: 78977247105 koristi kolačiće i slične tehnologije (dalje u tekstu: kolačići) na internetskoj stranici <a href="https://www.favbet.hr" target="_blank">www.favbet.hr</a> ( dalje u tekstu: internetska stranica), I mobilnu aplikaciju Favbet.hr (dalje u tekstu: Aplikacija) kako bi posjetiteljima mogli pružiti uslugu s potpunim funkcionalnostima i što kvalitetnijim sadržajem.</p>

    <h3>Što su kolačići i za što ih koristimo?</h3>
    <p>Kolačići su tekstualne datoteke smještene na računalo, mobilni telefon ili drugi uređaj kojim posjetitelj pristupa internetskoj stranici odnosno aplikaciji te se koriste za pokretanje stranice i korištenje svih njezinih funkcionalnosti, poboljšanje korisničkog iskustva, praćenje korištenja stranice i prikazivanje relevantnih ponuda.</p>
    <p>Kolačići na naše Internet mjestu nisu usmjereni na špijuniranje korisnika i ne slijede sve što korisnik radi te nisu zlonamjerni kod ili virus. Također nisu povezani s neželjenim porukama (spamom), ne spremaju korisničko ime i lozinku i nisu namijenjeni isključivo za reklame ili oglašavanje. Informacije poput Vašeg imena ili adrese elektroničke pošte neće biti spremljene - Internet mjesto ne može pristupiti Vašim osobnim informacijama i datotekama na Vašem računalu. Treba napomenuti da naše Internet mjesto funkcionira optimalno samo ako je omogućeno korištenje kolačića.</p>
    <h2>VRSTE KOLAČIĆA</h2>
    <h3>Kolačići prema trajanju</h3>
    <h4>Stalni kolačići</h4>
    <p>Stalni ili spremljeni kolačići ostaju na računalu nakon zatvaranja programa internet preglednika. Pomoću njih Internet mjesta pohranjuju podatke, kao što su ime za prijavu i lozinka, postavke jezika ili postavke o kolačićima tako da ih ne morate ponovno unositi prilikom svakog idućeg posjeta. Stalni kolačići mogu ostati na računalu ili mobilnom uređaju danima, mjesecima, čak i godinama.</p>
    <h4>Privremeni kolačići</h4>
    <p>Privremeni kolačići ili kolačići sesije uklanjaju se s računala po zatvaranju internet preglednika. Pomoću njih Internet mjesta pohranjuju privremene podatke, poput npr. posljednjih nekoliko stranica koje ste otvorili na Internet mjestu koje posjećujete ili stavki u košarici za kupnju ukoliko ste na Internet mjestu koje je specijalizirano za Internet prodaju.</p>
    <h3>Kolačići prema izvoru</h3>
    <h4>Kolačići prve strane <span class="oblique">(first party cookie)</span></h4>
    <p>Kolačići prve strane dolaze s Internet mjesta koje gledate, a mogu biti stalni ili privremeni. Pomoću tih kolačića Internet mjesta mogu pohraniti podatke koje će ponovo koristiti prilikom sljedećeg posjeta tom Internet mjestu.</p>
    <h4>Kolačići treće strane <span class="oblique">(third party cookie)</span></h4>
    <p>Kolačići treće strane dolaze s drugih Internet mjesta, a koje se nalaze na Internet mjestu koje gledate. Pomoću tih kolačića druga Internet mjesta mogu pratiti korištenje Interneta na Internet mjestu kog gledate u marketinške svrhe.</p>
    <p>Prilikom prikupljanja kolačića, moguća je pohrana određenih podataka od strane platforme Google Analytics. Za više podataka o pravilima privatnosti platforme Google Analytics, možete se informirati putem sljedećeg linka:<br><a href="https://policies.google.com/privacy?hl=hr" target="_blank">https://policies.google.com/privacy?hl=hr</a><br>Napominjemo da ne kontroliramo postavljanje ovih kolačića, pa se preporučuje provjeriti web stranicu treće strane za više informacija o njihovim kolačićima i kako njima upravljati.</p>
    <h3>Kolačići prema funkciji</h3>
    <h4>Tehnički kolačići - obavezni kolačići</h4>
    <p>(uvijek aktivni) - nužni za funkcioniranje Internet mjesta i ne mogu se isključiti u našim sustavima. Uobičajeno se postavljaju kao odgovor na vaše radnje koje uključuju zahtjev za uslugama, kao što su postavke kolačića, prijava ili ispunjavanje obrazaca. Svoj preglednik možete postaviti da blokira te kolačiće ili pošalje upozorenje o njima, ali u tom slučaju neki dijelovi stranice neće raditi. Ti kolačići ne pohranjuju nikakve informacije koje bi vas mogle identificirati.</p>
    <h4>Funkcionalni kolačići</h4>
    <p>(mogu se isključiti) - omogućuju Internet mjestu pružanje poboljšane funkcionalnosti i personalizaciju. Možemo ih postaviti mi ili pružatelji usluga trećih strana čije su usluge dodane na naše stranice. Ako ne omogućite te kolačiće, neke od tih funkcija možda neće pravilno funkcionirati.</p>
    <h4>Marketinški</h4>
    <p>(mogu se isključiti) - omogućuju bilježenje posjeta i izvora prometa kako bismo mogli mjeriti i poboljšati učinkovitost našeg Internet mjesta. Pomažu nam saznati koje su stranice najviše i najmanje popularne i vidjeti kako se posjetitelji kreću stranicom. Sve informacije koje ti kolačići prikupljaju akumuliraju se i stoga ostaju anonimni. Ako ne omogućite te kolačiće, nećemo znati kada ste posjetili našu stranicu i nećemo moći pratiti njezinu učinkovitost. Ne pohranjuju izravno osobne postavke, ali temelje se na jedinstvenoj identifikaciji vašeg preglednika i internetskog uređaja. Ako ne omogućite te kolačiće, susrest ćete se s manje ciljanim oglašavanjem.</p>
    <h4>Kako prihvatiti ili odbiti kolačiće</h4>
    
    <p>Okvir za postavke kolačića nalazi se u podnožju ovog Internet mjesta. Nakon odabira postavki, u svakom trenutku možete postaviti na početne postavke kolačića također u podnožju ovog Internet mjesta.</p>
    <p>Odabirom opcije Prihvaćam sve kolačiće dopuštate pohranjivanje svih gore navedenih kolačića na vaše računalo ili mobilni uređaj.</p>
    <p>Odabirom opcije Prihvaćam samo neophodne kolačiće na vaše računalo ili mobilni uređaj pohranjuju se samo vrijednosti za tehničke-obavezne kolačiće.</p>
    <p>Ako onemogućite kolačiće, možda nećete moći koristiti neke od funkcionalnosti ovog Internet mjesta.</p>
    <p>Dodatno možete prihvatiti ili odbiti neke ili sve kolačiće prilagođavanjem postavki Vašeg preglednika. Na sljedećim poveznicama možete pronaći informacije o tome kako promijeniti postavke za neke od najčešće korištenih Internet preglednika: Mozilla Firefox, Google Chrome, Microsoft Internet Explorer, Apple Safari, Opera.  Neki preglednici Vam omogućuju kretanje kroz Internet mjesto u "anonimnom" načinu rada, ograničavajući količinu podataka postavljenih na vašem računalu i automatsko brisanje trajnih kolačića postavljenih na vaše računalo ili mobilni uređaj kada završite sesiju pregledavanja. Postoje i mnoge aplikacije trećih strana koje možete dodati u preglednik da biste blokirali ili upravljali kolačićima. Možete i izbrisati kolačiće koji su prethodno bili postavljeni u vaš preglednik tako da odaberete opciju za brisanje povijesti pregledavanja i pritom uključite i opciju brisanja kolačića. Detaljnije informacije o kolačićima i podešavanje postavki preglednika možete pronaći na stranici <a href="https://allaboutcookies.org" target="_blank" >www.allaboutcookies.org</a>.</p>
    <p>Korisni vodiče za kolačiće:</p>
    <ul>
        <li>Chrome: <a href="https://support.google.com/chrome/bin/answer.py?hl=en&answer=95647&p=cpn_cookies" target="_blank">https://support.google.com/chrome/bin/answer.py?hl=en&answer=95647&p=cpn_cookies</a></li>
        <li>Firefox: <a href="http://support.mozilla.org/en-US/kb/Cookies" target="_blank">http://support.mozilla.org/en-US/kb/Cookies</a></li>
        <li>Internet Explorer: <a href="http://support.microsoft.com/kb/278835" target="_blank">http://support.microsoft.com/kb/278835</a></li>
        <li>Safari 5 za Mac: <a href="http://docs.info.apple.com/article.html?path=Safari/5.0/en/9277.html" target="_blank">http://docs.info.apple.com/article.html?path=Safari/5.0/en/9277.html</a></li>
        <li>Opera: <a href="http://help.opera.com/Linux/10.50/en/cookies.html" target="_blank">http://help.opera.com/Linux/10.50/en/cookies.html</a></li>
    </ul>
    <p>
        Osim toga, <span class="oblique">Google Analytics</span> pruža vlastite mogućnosti odjave:<br>
        <a href="http://tools.google.com/dlpage/gaoptout" target="_blank">http://tools.google.com/dlpage/gaoptout</a>
    </p>
    <h4>Koristimo sljedeće vrste kolačića:</h4>
    <ul>
        <li>Obavezne kolačiće</li>
        <li>Analitičke kolačiće</li>
        <li>Marketinški kolačiće</li>
        <li>•\tNerazvrstani</li>
    </ul>
    
    <p>Obavezne kolačiće odnosno kolačiće koji osiguravaju pravilan rad internetske stranice i aplikacije koristimo za korištenje glavnih funkcija internetske stranice i aplikacije, za osiguranje sigurnosti i za omogućavanje upravljanja mrežom (npr. kolačići sesije koji drže korisnike prijavljenima dok se kreću po stranici i kolačići koji spremaju prilagođene korisničke postavke). Bez obveznih kolačića internetska stranica odnosno aplikacija ne može ispravno raditi te za razliku od analitičkih, marketinških i kolačića za personalizaciju, za njih ne tražimo pristanak posjetitelja.</p>
    <p>Analitičke kolačiće koristimo za praćenje upotrebe internetske stranice i aplikacije, broja posjetitelja, vremena zadržavanja, analizu prometa i optimizaciju internetske stranice i aplikacije. Pomažu nam razumjeti i mjeriti interakciju posjetitelja s internetskom stranicom i aplikacijom, njihovo bolje razumijevanje i poboljšanje načina rada. Također nam omogućuju testiranje sadržaja i značajki kako bismo poboljšali iskustvo i izgled internetske stranice i aplikacije.</p>
    <p>Marketinške kolačiće i kolačiće za personalizaciju koristimo da bi posjetiteljima mogli pružiti prilagođenu ponudu na temelju njihovih preferencija temeljem korištenja internetske stranice. Prikupljene podatke o upotrebi internetske stranice možemo koristiti zajedno s osobnim podacima onih posjetitelja koji su dali privolu za marketinško kontaktiranje kako bismo našu marketinšku komunikaciju prilagodili potrebama i interesima posjetitelja.</p>
    <p>Nerazvrstani kolačići su kolačići koji ne spadaju ni u jednu drugu kategoriju ili su još u procesu kategorizacije.</p>
    <p>U svakom trenutku možete izmijeniti postavke kolačića i povući odnosno dati svoj pristanak za korištenje neobveznih kolačića <span class="showCookieManagementButton" onClick="window.showCookieManagement()">ovdje</span>.</p>
    <p>Imajte na umu da neke usluge mogu biti osmišljene tako da funkcioniraju uz korištenje kolačića i da onemogućivanje kolačića može utjecati na Vašu mogućnost korištenja tih usluga ili određenih dijelova usluga.</p>
    <p>Svaku izmjenu Politike o kolačićima objavit ćemo na ovoj stranici te predlažemo da povremeno posjetite ovu stranicu radi informiranja o mogućim izmjenama naše politike o kolačićima.</p>
</div>
`;
